import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {QualityControlApprovalsData} from "../../types/quality-control-approvals.types";
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";
import {SelectData} from "../../../../../../../../core/types/records-table.types";

@Component({
  selector: 'app-quality-control-approvals-title',
  imports: [
    MatIcon,
    MatMiniFabButton
  ],
  templateUrl: './quality-control-approvals-title.component.html',
  styleUrl: './quality-control-approvals-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QualityControlApprovalsTitleComponent {
  data = input.required<QualityControlApprovalsData>();
  approvalStatusSelectData = input<Array<SelectData>>([]);
  isEditModeActive = input.required<boolean>();
  handleDelete = output<MouseEvent>();

  public titleText = computed(() => this.approvalStatusSelectData().find(i => String(i.id) === this.data().approvalStatus)?.value || 'Новое');
}
